"use client";
import { cva as r } from "class-variance-authority";
const e = r(
  [
    "w-full min-w-0 outline-none relative",
    "appearance-none [transition-property:common]",
    "[transition-duration:0.02s]",
    "disabled:opacity-40 disabled:cursor-not-allowed",
    "[--focus-border-color:theme(colors.blue.500)]",
    "[--error-border-color:theme(colors.red.500)]",
    "dark:[--focus-border-color:theme(colors.blue.300)]",
    "dark:[--error-border-color:theme(colors.red.300)]"
  ],
  {
    variants: {
      variant: {
        outline: [
          "border border-inherit bg-inherit",
          "focus:[&:not([data-invalid])]:border-[--focus-border-color]",
          "focus:[&:not([data-invalid])]:shadow-[0_0_0_1px_var(--focus-border-color)]",
          "data-[invalid]:border-[--error-border-color]",
          "data-[invalid]:shadow-[0_0_0_1px_var(--error-border-color)]"
        ]
      },
      size: {
        md: "p-4 h-10 text-md rounded-md",
        sm: "px-3 py-2 text-sm rounded-md"
      }
    }
  }
);
export {
  e as input
};
